import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { SportsExtractHourPipe } from "@sports-pipes/sports.extract-hour.pipe";

@Component({
  selector: "sb-grid-filter",
  templateUrl: "./sb-grid-filter.html",
  styleUrls: ["./sb-grid-filter.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, SportsExtractHourPipe],
})
export class SbGridFilterComponent implements OnChanges, AfterViewInit {
  @ViewChild("content") content: ElementRef;
  @Input() bgColor: string;
  @Input() currentEvent: any;
  @Output() select: EventEmitter<any> = new EventEmitter();
  @Input() collapsed: boolean = true;
  @Input() blocked: boolean = false;
  @Input() isTicket: boolean = false;
  @Input() isRace: boolean = false;
  @Input() showIcon: boolean = false;
  @Input() currentPage: string;
  private _content: HTMLElement;

  private _element = inject(ElementRef);
  private _renderer = inject(Renderer2);

  ngOnChanges(changes: SimpleChanges) {
    if (!changes["currentEvent"]) {
      return;
    }
    if (!changes["currentEvent"].currentValue || !changes["currentEvent"].previousValue) {
      return;
    }

    if (
      changes["currentEvent"].currentValue !== changes["currentEvent"].previousValue &&
      !this.isTicket &&
      !this.isRace
    ) {
      this.toggle();
    }
  }

  ngAfterViewInit() {
    this._content = this.content.nativeElement;
    this._renderer.addClass(this._content, this.bgColor);
    if (this.currentPage) {
      this._renderer.addClass(this._element.nativeElement, this.currentPage);
    }
  }

  get isCollapsed() {
    return this.isTicket ? this.collapsed : !this.currentEvent?.Selected;
  }

  // @HostListener('click')
  public toggle() {
    if (this.blocked) {
      return;
    }

    if (!this.isTicket) {
      this.collapsed = !this.collapsed;
      this.select.emit(this.currentEvent);
    } else {
      this.select.emit(this.collapsed);
    }
  }

  // private _toggle(){
  //   let method = this.collapsed ? 'false' : 'true';
  // }
}
